export default "__VITE_ASSET__DQkJj8Tg__"